export default {
  DEGREE: {
    OTHERS: 'Others',
    JUNIOR_SCHOOL: 'Primary / Junior School',
    HIGH_SCHOOL: 'High School / Secondary School',
    SECONDARY_TECHNICAL_SCHOOL: 'Secondary Technical School',
    JUNIOR_COLLEGE: 'Polytechnic / Jr. College / ITE',
    GRADUATE: 'Graduate (no bachelor degree)',
    BACHELOR: 'Bachelor',
    MASTER: 'Master',
    PHD: 'PHD'
  },
  JOB_TYPE: {
    SCHOOL_LEAVER: 'Fresh Graduate',
    EXPERIENCED: 'Experienced'
  },
  ROLE_TYPE: {
    FULL_TIME: 'Full Time',
    PART_TIME: 'Part Time',
    INTERNSHIP: 'Intern'
  },
  LANGUAGE: {
    ARABIC: 'Arabic',
    CANTONESE: 'Cantonese',
    ENGLISH: 'English',
    FRENCH: 'French',
    GERMAN: 'German',
    HINDI_OR_URDU: 'Hindi/Urdu',
    ITALIAN: 'Italian',
    JAPANESE: 'Japanese',
    KOREAN: 'Korean',
    MANDARIN: 'Mandarin',
    RUSSIAN: 'Russian',
    SPANISH: 'Spanish',
    TAMIL: 'Tamil',
    MALAY: 'Malay',
    BURMESE: 'Burmese',
    KHMER: 'Khmer',
    TETUM: 'Tetum',
    PORTUGUESE: 'Portuguese',
    INDONESIAN: 'Indonesian',
    LAO: 'Lao',
    BENGALI: 'Bengali',
    FILIPINO: 'Filipino',
    THAI: 'Thai',
    VIETNAMESE: 'Vietnamese',
    SINHALESE: 'Sinhalese'
  },
  LANGUAGE_LEVEL: {
    NATIVE: 'Native',
    FLU: 'Proficient in listening, speaking, reading and writing',
    SCC: 'Proficient in listening and speaking, average in reading and writing',
    LIT: 'Average in listening and speaking, proficient in reading and writing',
    BAS: 'Average in listening, speaking, reading and writing'
  },
  CERTIFICATION: {
    CET4: 'CET 4',
    CET6: 'CET 6',
    TEM4: 'TEM 4',
    TEM8: 'TEM 8',
    PETS1: 'PETS 1',
    PETS2: 'PETS 2',
    PETS3: 'PETS 3',
    PETS4: 'PETS 4',
    PETS5: 'PETS 5',
    TOEFL: 'TOEFL',
    IELTS: 'IELTS',
    OTHER: 'Other'
  },
  CHAT_TOOL: {
    QQ: 'QQ',
    ALWW: 'Aliwanwang',
    FLY_XIN: 'Flyxin',
    LINE: 'LINE',
    MI_LIAO: 'Miliao',
    MO_MO: 'Momo',
    MSN: 'MSN',
    PAPA: 'Papa',
    SKYPE: 'Skype',
    TM: 'TM',
    YY: 'YYyuyin'
  },
  SOCIAL_NETWORK: {
    BAI_DU_TIE_BA: 'Baidu Tieba',
    BLOG: 'Blog',
    DOU_BAN: 'Douban',
    FACEBOOK: 'Facebook',
    KAIXIN: 'Kaixin',
    LINKEDIN: 'LinkedIn',
    MOP: 'Mop',
    QQ_ZONE: 'Qzone',
    REN_REN: 'Renren',
    SOHU_WEI_BO: 'Sohu Weibo',
    TIANYA: 'Tianya',
    TWITTER: 'Twitter',
    TENCENT_WEI_BO: 'Tencent Weibo',
    WEICHAT: 'Weixin',
    SINA_WEI_BO: 'Sina Weibo'
  }
}
